export default __webpack_public_path__ + "static/media/login.7de4c841.png";